<template>
    <GuideModal :type="type" v-if="guideModal" />
    <div class="mainWrap list">
      <div class="subCont whiteDoc">
        <TitleView />
        <div class="analysis-btn-container">
          <button
            v-for="(label, index) in [$t('analysis.futures'), $t('analysis.spot')]"
            :key="index"
            @click="coinChange(index)"
            class="analysis-button"
            :class="{ selectType: coinTab === index }"
          >
            {{ label }}
          </button>
        </div>
        <div class="wrapper-analysis">

        <!-- analysis -->
        <div class="analysis-wrapper">
          <div class="analysis-coin-title">
            <TitleSection
              :title="$t('analysis.coinData')"
              @guideClick="openGuide(1)"
              type="analysis"
              v-model:searchCoin="searchCoin"
            />
  
            <div id="screen__pc" class="analysis-container">
              <CoinList :searchCoin="searchCoin" />
            </div>
            <div id="screen__mobile" class="analysis-container">
              <CoinListMobile :searchCoin="searchCoin" />
            </div>
          </div>
  
          <!-- HeatMap -->
          <div class="heatmap-container-wrapper">
            <TitleSection
              :title="$t('analysis.heatMap')"
              @guideClick="openGuide(2)"
            />
  
            <div class="heatmap-container">
              <div class="button-group" :class="lang">
                <template v-for="option in heatMapOptions" :key="option.id">
                  <input
                  type="radio"
                  :id="option.id"
                  name="filter"
                  :checked="type === option.type"
                  @click="typeChange(option.key)"
                  />
                  <label :for="option.id">{{ $t(option.label) }}</label>
                </template>
              </div>
  
              <div :id="windowWidth > 1200 ? 'screen__pc' : 'screen__mobile'" class="heatmap-content">
                <HeatMap />
              </div>
            </div>
          </div>

            <!-- ratio -->
            <div class="ratio-wrapper">
                <TitleSection
                    :title="$t('signal.signal')"
                    @guideClick="openGuide(3)"
                />
                <div  :id="windowWidth > 1200 ? 'screen__pc' : 'screen__mobile'" class="ratio-chart-wrapper" style="width: 100%;">
                    <div class="siganl-select">
                        <select v-model="coinTime">
                            <option value="1h">1 hour</option>
                            <option value="4h">4 hour</option>
                            <option value="12h">12hour</option>
                            <option value="24h">24hour</option>
                        </select>
                    </div>
                    <RatioChart />
                </div>
            </div>

            <!-- exchange -->
            <div class="exchange-wrapper">
              <TitleSection
                  :title="$t('signal.ratio')"
                  @guideClick="openGuide(4)"
              />
              <div id="screen__pc" class="exchage-list-wrapper">
                <VsRatio :positionData="positionData" />
              </div>
              <div id="screen__mobile" class="exchage-list-wrapper">
                <VsRatioMobile :positionData="positionData" />
              </div>
            </div>

            <!-- liquidation -->
            <div class="clearing-wrapper">
              <TitleSection
                  :title="$t('liq.liqMAp')"
                  @guideClick="openGuide(5)"
              />
              <div :id="windowWidth > 1200 ? 'screen__pc' : 'screen__mobile'" class="clearing-chart-wrapper" style="width: 100%;">
                  <div class="select-date">
                      <select v-model="coinDate">
                      <option value="1d">1D</option>
                      <option value="7d">7D</option>
                      </select>
                  </div>
                  <ClearingChart />
                </div>
              </div>  
            </div>

        </div>
    </div>
</div>
</template>
  
<script>
import "@/assets/css/analysis.css";
import TitleView from "@/components/public/TitleView.vue";
import TitleSection from "@/components/analysis/sub/TitleSection.vue";
import GuideModal from "@/components/public/GuideModal.vue";

// heat map
import HeatMap from "@/components/analysis/chart/HeatMap.vue";

// coin list
import CoinList from "@/components/analysis/sub/CoinList.vue";
import CoinListMobile from "./sub/CoinListMobile.vue";

// // ratio
import RatioChart from "@/components/signal/chart/RatioChart.vue";

// trader long/short
import VsRatio from "@/components/signal/sub/VsRatio.vue";
import VsRatioMobile from "@/components/signal/sub/VsRatioMobile.vue";

// liquidation
import ClearingChart from "@/components/clearing/chart/ClearingChart.vue"

import { mapMutations, mapState, mapActions } from "vuex";

export default {
  name: "PriceVolume",
  components: {
    TitleView,
    TitleSection,
    GuideModal,
    HeatMap,
    CoinList,
    CoinListMobile,
    RatioChart,
    VsRatio,
    VsRatioMobile,
    ClearingChart,
  },
  data() {
    return {
      searchCoin: "",
      type: 2, // 기본: liquidation
      lang: localStorage.getItem("lang") || "en",
      heatMapOptions: [
        { id: "volume", key: "volume", label: "analysis.volume", type: 0 },
        { id: "variation", key: "change", label: "analysis.variation", type: 1 },
        { id: "liquidation", key: "liq", label: "analysis.liquidation", type: 2 },
      ],
      coinTime: "1h",
      cocntentType: 2,
      coinDate: "1d",
      windowWidth: window.innerWidth,
      zingObserver: null
    };
  },
    computed: {
        ...mapState("signal", ["positionData"]),
        ...mapState("analysis", ["coinList", "coinTab"]),
        ...mapState("dominance", ["guideModal"]),
    },
    async created() {
      await this.loadFuterCoin();
      await this.loadPosition();
      window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.handleResize);
      if (this.zingObserver) {
        this.zingObserver.disconnect();
      }
    },
    mounted() {
      this.chkId();
    },
    methods: {
        ...mapMutations("dominance", ["changeGuide"]),
        ...mapMutations("analysis", ["changeList", "changeType", "changeLoad"]),
        ...mapActions("analysis", ["loadFuterCoin"]),

        ...mapMutations("signal", ["changSignalTime"]),
        ...mapActions("signal", ["loadPosition"]),

        ...mapMutations("clearing", ["changeDay"]),
        ...mapActions("clearing", ["loadClearing"]),

        coinChange(type) {
          this.changeList(type);
        },
        typeChange(type) {
          this.type = this.heatMapOptions.find((o) => o.key === type)?.type || 0;
          this.changeType(type);
        },
        openGuide(type) {
          this.type = type;
          this.changeGuide(true);
        },
        handleResize() {
          this.windowWidth = window.innerWidth;
        },
        chkId() {
          const observer = new MutationObserver(() => {
            const zingBtn = document.querySelectorAll('[id*="license-text"]');
            if (zingBtn.length > 0) {
              zingBtn.forEach(el => {
                el.style.display = 'none';
              });
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
    },
    watch: {
      coinTime() {
        this.changSignalTime(this.coinTime)
      },
      coinDate(newVal) {
        this.changeDay(newVal);
        this.loadClearing(newVal);
      },
    }
};

</script>